import React from 'react';
import { motion } from 'framer-motion';

export default function FantaDetail() {
  const slideUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  const hoverImage = 'transition-transform duration-500 hover:scale-105';

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 md:px-10 lg:px-20 mt-10">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-10">

        {/* Main Content */}
        <div className="lg:col-span-2 space-y-12">

          {/* Section Card */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            variants={slideUp}
            className="bg-white rounded-3xl shadow-lg overflow-hidden group"
          >
            <div className="relative h-64 md:h-[400px] overflow-hidden">
              <img
                src="https://eskimi-creatives.com/Samsung_Fold_6/site-images/1.jpg"
                alt="Ad Visual"
                className={`w-full h-full object-cover ${hoverImage}`}
              />
              <div className="absolute top-4 right-4 bg-black bg-opacity-50 text-white text-xs px-3 py-1 rounded-full">
                Advertising
              </div>
            </div>
            <div className="p-8">
              <h1 className="text-4xl font-bold text-gray-800 mb-4">Stunning Campaign</h1>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Explore the future of foldable phones through this engaging advertisement campaign.
              </p>
              <div className="flex justify-between text-xs text-gray-500 pt-4 border-t border-gray-200">
                <span>Category: Advertising</span>
                <span>36 Comments</span>
              </div>
            </div>
          </motion.div>
         
        </div>

        {/* Sidebar */}
        <div className="space-y-10">

          {/* Sidebar Video */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            variants={slideUp}
            className=" overflow-hidden relative"
          >
            <video
              className="w-full h-[500px] object-cover"
              autoPlay
              muted
              playsInline
              loop
            >
              <source src="https://eskimi-creatives.com/Samsung_Fold_6/300x600_fold_1/images/video.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="absolute bottom-4 left-4 right-4 flex justify-between text-xs text-white bg-black bg-opacity-50 px-3 py-1 rounded">
              <span>300×600</span>
              <span>ID: 1557042</span>
            </div>
          </motion.div>

          {/* Sidebar Image Card */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            variants={slideUp}
            className="bg-white rounded-3xl shadow-lg overflow-hidden group"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=2070&q=80"
                alt="Sidebar Visual"
                className={`w-full h-full object-cover ${hoverImage}`}
              />
              <div className="absolute top-4 right-4 bg-black bg-opacity-50 text-white text-xs px-3 py-1 rounded-full">
                Sidebar
              </div>
            </div>
            <div className="p-6">
              <h2 className="text-xl font-bold text-gray-800 mb-2">ID: 1557042</h2>
              <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                Highlighting key ad assets with smooth animations and clean visuals.
              </p>
              <div className="flex justify-between text-xs text-gray-500 pt-4 border-t border-gray-200">
                <span>Category: Advertising</span>
                <span>76 Comments</span>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </div>
  );
}